import { useTranslate } from '@festina-life/ui/hooks'
import { Stack, Typography } from '@festina-life/ui/structure'

import { useOperationsContext } from '../../workspace/operationsContext'
import { countShadowedOperations } from '../../workspace/shadowedOperationsHelpers'
import { ShadowedTemplateLinks } from '../shadowedTemplateLinks/ShadowedTemplateLinks'

export const UnifiedShadowedOperationsPanel = () => {
  const translate = useTranslate()
  const {
    branchKey,
    workspaceKey,
    branchShadowedTemplateOperations,
    workspaceShadowedTemplateOperations,
  } = useOperationsContext()

  const hasBranchShadowed = !!countShadowedOperations(
    branchShadowedTemplateOperations,
  )
  const hasWorkspaceShadowed = !!countShadowedOperations(
    workspaceShadowedTemplateOperations,
  )

  return (
    <Stack gap="spacious" padding="condensed" className="flex-col">
      {hasBranchShadowed && branchKey && (
        <Stack gap="condensed" className="flex-col">
          <Typography as="h3" weight="semibold" className="mb-1">
            {translate(
              'unifiedBranchWorkspacePanel.tabs.shadowed.section.branch',
            )}
          </Typography>
          <ShadowedTemplateLinks
            conflicts={branchShadowedTemplateOperations}
            branch={branchKey}
            workspaceName={workspaceKey?.name}
          />
        </Stack>
      )}
      {hasWorkspaceShadowed && branchKey && workspaceKey && (
        <Stack gap="condensed" className="flex-col">
          <Typography as="h3" weight="semibold" className="mb-1">
            {translate(
              'unifiedBranchWorkspacePanel.tabs.shadowed.section.workspace',
            )}
          </Typography>
          <ShadowedTemplateLinks
            conflicts={workspaceShadowedTemplateOperations}
            branch={branchKey}
            workspaceName={workspaceKey.name}
          />
        </Stack>
      )}
    </Stack>
  )
}
